import "./../areaChart.css";

import * as d3 from "d3";
import React, { useEffect } from "react";

interface AreaChartXAxisProps {
    height: number;
    margin: number;
    xScale: d3.ScaleLinear<number, number>;
    tickValues: number[];
    mobile: boolean;
    tickFormat?: (x: d3.NumberValue) => string;
    d3Id: string;
}

export const AreaChartXAxis = (props: AreaChartXAxisProps) => {
    const {
        height,
        margin,
        xScale,
        tickValues,
        mobile = true,
        tickFormat = x => x + "th",
        d3Id,
    } = props;

    useEffect(() => {
        // create axis
        const xAxis = d3
            .axisBottom(xScale)
            .tickSize(0)
            .tickValues(tickValues)
            .tickFormat(x => tickFormat(x));

        // appending x axis and removing axis line
        d3.select(`#${d3Id}`)
            .selectAll(".x-axis")
            .append("g")
            .call(xAxis)
            .select(".domain")
            .remove();

        // customize x axis text
        d3.select(`#${d3Id}`)
            .selectAll(".x-axis text")
            .attr("transform", mobile ? "translate(24,10)" : "translate(6,5)")
            .attr("font-size", mobile ? 20 : 6)
            .attr("font-weight", "normal")
            .style("text-anchor", "end")
            .style("fill", "#222222")
            .attr("font-family", "'hkgrotesk_regular'")
            .style("opacity", 0.8);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <g
            className="x-axis"
            transform={`translate(0, ${height - margin * 2})`}
        ></g>
    );
};
